<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> CONDIÇÃO DE PAGAMENTO </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="paymentCondition.id"
          >{{ paymentCondition.id }} -
          {{ paymentCondition.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="paymentCondition.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-select
                v-model="paymentCondition.installments"
                :items="number_installments"
                label="Número de Parcelas"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="4">
              <v-switch
                class="mt-1"
                v-model="paymentCondition.special_condition"
                :true-value="1"
                :false-value="0"
                label="Condição Promocional"
                messages="Condição de Pagamento visível somente para a Franqueadora."
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="3"> Intervalo entre as Parcelas </v-col>
            <v-col cols="12" xs="9">
              <v-text-field
                v-for="(item, index) in paymentCondition.installments"
                :key="item"
                style="
                  width: 50px;
                  font-size: 12px;
                  display: inline;
                  float: left;
                  margin-left: 2px;
                "
                v-model="terms[index]"
                dense
                hide-details
                outlined
                required
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import { URL } from "@/api/config";
export default {
  components: {},
  data: () => ({
    loading: false,
    index_types: [
      { value: "desconto", text: "Desconto" },
      { value: "acrescimo", text: "Acréscimo" },
    ],
    number_installments: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
    installments_input: [],
    paymentCondition: {
      id: "",
      name: "",
      installments: 1,
      index_type: "desconto",
      index_value: "1.0000",
      status: 1,
      terms: [],
    },
    terms: [],
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getPaymentCondition(this.$route.params.id);
      }
    },
    async getPaymentCondition(id) {
      // this.showLoading();
      this.loading = true;
      try {
        let response = await fetch(`${URL}payment-condition/${id}`);
        let data = await response.json();
        this.terms = data.terms.map((item) => item.days);
        console.log(this.terms);
        this.paymentCondition = data;
      } catch (error) {
        this.paymentCondition = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    goToBackList() {
      this.$router.push({ name: "PaymentCondition" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.paymentCondition.name = this.paymentCondition.name.toUpperCase();
        this.paymentCondition.terms = this.terms.slice(
          0,
          this.paymentCondition.installments
        );
        let data = new URLSearchParams(this.paymentCondition);
        if (this.paymentCondition.id === "") {
          this.post(data);
        } else {
          this.update(this.paymentCondition.id, data);
        }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        let res = await fetch(`${URL}payment-condition`, {
          method: "POST",
          body: data,
        });
        if (res) {
          // this.showAlert({
          //   message: "Tipo de Fornecedor salvo com sucesso",
          //   type: "success",
          // });
          this.goToBackList();
        }
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        let res = await fetch(`${URL}payment-condition/${id}`, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
          method: "PUT",
          body: data,
        });
        if (res) {
          // this.showAlert({
          //   message: "Tipo de Fornecedor atualizado com sucesso",
          //   type: "success",
          // });
          this.goToBackList();
        }
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
